import { cx } from '@orn/shared-web/utils/cx';

interface IAlertActionErrorProps {
  /** What failed, in one sentence, in terms the user can act on. */
  message: string;
  className?: string;
}

/**
 * Failure line for an alert row's own action, rendered under the list it was
 * started from. Purely presentational.
 *
 * The reconnect path is what needs it: handed a connection to reconnect,
 * `useAccountLink` skips the institution modal, which is the only place it
 * would otherwise surface a link error.
 */
const AlertActionError = ({ message, className }: IAlertActionErrorProps) => (
  <div className={cx('bg-error-secondary text-error-primary rounded-lg px-3 py-2 text-sm', className)}>{message}</div>
);

export default AlertActionError;
